/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventUnlockConditions } from './eventUnlockConditions';

export type EventTaskConfigUnlockConditions = EventUnlockConditions | null;
